import { createContext } from 'preact';
import { useContext, useEffect } from 'preact/hooks';

/**
 * Retiene expandido el raíl lateral mientras un menú abierto desde él siga
 * abierto. Los menús se pintan en un portal, fuera del raíl: sin esto, llevar
 * el ratón al menú dispara el mouseleave del raíl y lo pliega bajo el menú.
 */
export const SidebarHoldContext = createContext<(held: boolean) => void>(() => {});

export function useHoldSidebarWhile(open: boolean) {
  const hold = useContext(SidebarHoldContext);
  useEffect(() => {
    if (!open) return;
    hold(true);
    return () => hold(false);
  }, [open, hold]);
}
